'use client';
import React from 'react';
import Link from 'next/link';
import { ShieldCheck, Clock, CheckCircle } from 'lucide-react';
import TTOSRobotMascot from './TTOSRobotMascot';

export const TTOSCTABanner: React.FC = () => {
  return (
    <section className="py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Vibrant Purple Gradient Banner */}
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-r from-[#6366F1] via-[#7C3AED] to-[#4F46E5] p-8 sm:p-12 text-white shadow-2xl">
          
          {/* Background Radial Glow */}
          <div className="absolute top-0 right-1/3 w-80 h-80 bg-white/10 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            
            {/* Left Texts & Actions */}
            <div className="space-y-4 max-w-xl text-center lg:text-left">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight text-white">
                Ready to Transform Your Business?
              </h2>
              <p className="text-sm sm:text-base text-purple-100 font-normal leading-relaxed">
                Join thousands of businesses that trust TT OS to grow their business.
              </p>

              <div className="pt-2 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <Link
                  href="/register"
                  className="px-7 py-3 rounded-full bg-white text-purple-700 hover:bg-slate-50 text-xs sm:text-sm font-extrabold shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 active:scale-95"
                >
                  Start Free Now
                </Link>
              </div>

              {/* Badges */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 pt-2 text-[11px] text-purple-100 font-medium">
                <div className="flex items-center gap-1.5">
                  <ShieldCheck className="w-3.5 h-3.5 text-purple-200" />
                  <span>No Credit Card</span>
                </div>
                <span>•</span>
                <div className="flex items-center gap-1.5">
                  <Clock className="w-3.5 h-3.5 text-purple-200" />
                  <span>14 Days Free Trial</span>
                </div>
                <span>•</span>
                <div className="flex items-center gap-1.5">
                  <CheckCircle className="w-3.5 h-3.5 text-purple-200" />
                  <span>Cancel Anytime</span>
                </div>
              </div>
            </div>

            {/* Right Mascot Visual */}
            <div className="shrink-0 relative">
              <TTOSRobotMascot size={170} glow={true} />
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default TTOSCTABanner;
